import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { CmsNewsComponent } from '../../../../core/model';
import { hasCmsStyleClass } from '../../../../shared';
import { News } from '../base/model';
import { NewsService } from '../base/services';

@Component({
  selector: 'py-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  standalone: false,
})
export class NewsComponent implements OnInit {
  @ViewChild('containerSizeRef', { read: ElementRef }) containerSizeRef: ElementRef;

  allNews$: Observable<News[]>;
  styleClasses$: Observable<string>;
  latestNewsItem$: Observable<News>;
  newsList$: Observable<News[]>;
  showMorePageUrl$: Observable<string>;

  showContentsListStyle: boolean;

  constructor(
    private cmsComponent: CmsComponentData<CmsNewsComponent>,
    private newsService: NewsService
  ) {}

  ngOnInit(): void {
    const data$ = this.cmsComponent.data$.pipe(
      tap((data) => {
        this.showContentsListStyle =
          (data?.styleClasses?.includes && data?.styleClasses?.includes('puff-collection-content-bottom')) || false;
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.styleClasses$ = this.cmsComponent.data$.pipe(map((data) => data?.styleClasses || ''));

    this.allNews$ = data$.pipe(
      switchMap((data) => this.newsService.getNews(data?.listingSize)),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.latestNewsItem$ = this.allNews$.pipe(
      filter(() => !this.showContentsListStyle),
      map((allNews) => (allNews?.length > 0 ? allNews[0] : undefined))
    );
    this.newsList$ = this.allNews$.pipe(
      filter(() => !this.showContentsListStyle),
      map((allNews) => allNews?.slice(1) ?? [])
    );
    this.showMorePageUrl$ = data$.pipe(
      filter(() => !this.showContentsListStyle),
      map((data) => data?.showMorePageUrl)
    );
  }

  hasClass(className: string, styleClass: string): boolean {
    return hasCmsStyleClass(className, styleClass);
  }
}
